import { Badge } from "@nexus/ui";
import { useTranslation } from "react-i18next";

import { ScriptReviewAction } from "@/features/marketplace/components/ScriptReviewAction";

import type { PartnerHookSlot } from "../lib/partner-script-production";

/** One hook's label, delivery badge and review link. */
export function PartnerHookSlotHeader({
  slot,
  label,
  title,
  headingAs: Heading,
  headingId,
}: {
  slot: PartnerHookSlot;
  label: string;
  title: string;
  headingAs: "h3" | "h4";
  headingId?: string;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <Heading id={headingId} className="text-sm font-medium text-foreground">
          {label}
        </Heading>
        <Badge variant={slot.isDelivered ? "status-delivered" : "outline"}>
          {slot.isDelivered
            ? t("marketplace.partner.workspace.hookDelivered", "Video delivered")
            : t("marketplace.partner.workspace.hookAwaitingVideo", "Waiting for video")}
        </Badge>
      </div>
      <ScriptReviewAction
        scriptReviewId={slot.scriptReviewId}
        preflightUrl={null}
        label={t("marketplace.partner.actions.viewVideoReview", "View video review")}
        ariaLabel={t("marketplace.partner.workspace.hookReviewAria", {
          hook: label,
          title,
          defaultValue: "View the {{hook}} video review for {{title}} (opens in a new tab)",
        })}
        variant="outline"
        size="sm"
        compact
      />
    </div>
  );
}
